export const CONTENT = {
  hero: {
    ca: '0x0f7dC5D02CC1E1f5Ee47854d534D332A1081cCC8',
    buyLink: 'https://app.uniswap.org/swap?chain=mainnet&inputCurrency=NATIVE&outputCurrency=0x0f7dc5d02cc1e1f5ee47854d534d332a1081ccc8',
  },
  social: {
    x: 'https://x.com/pepesdog_en',
    telegram: 'https://t.me/+oC_dPpWk4_IwMzM0',
    coinmarketcap: 'https://coinmarketcap.com/currencies/pepes-dog/',
    youtube: 'https://www.youtube.com/@pepesdogcto',
  },
  menu: {
    referral: 'https://ref.pepes.dog',
    ens: '/ens',
    governance: '/governance',
    earn: 'https://earn.pepes.dog',
    bridge: 'https://bridge.pepes.dog',
  },
  about: {
    paragraphs: [
      "$ZEUS is Pepe's dog, a character inspired by the world of Matt Furie's Boy's Club comics. He spent years hanging around the swamp in the background while the frogs got all the attention.",
      "It all started with a real dog. Zeus belongs to Jon \"Jagged\" Eyrick, and on February 7, 2022 the artist ndhaus drew him as a personal gift for Jagged: \"The Happiness of Zeus\", in the Boy's Club style.",
      "Fan artists picked him up, he started showing up in new Pepe art and the Rare Pepes community began calling him \"Pepe's dog\". Now he has his own token on Ethereum, run by the community that loves him.",
      "Zeus has officially secured trademark protection over the $ZEUS name and visual identity, which gives this community project a solid legal base. Behind it are ND Haus (the original artist), Jon \"Jagged\" Eyrick (owner of the real dog and of the IP) and the people who were here from the start.",
    ],
    trademarkLink: 'https://euipo.europa.eu/eSearch/#details/trademarks/019198567'
  },
  aboutCto: {
    paragraphs: [
      "In October 2025, the Pepes Dog community took over the project. Jaggedsoft and the founding team gave the green light to the CTO initiative. There is no company and no single person behind it. The people who lead it are community members who stepped up.",
      "Nobody here is waiting to cash out. The community pays for the project itself and puts thousands of dollars a month into new tools, events and partnerships.",
      "The plan is to keep stacking $ZEUS until it lists on a perps market, so holders can hedge. Big holders then earn by providing liquidity and collecting the fees from the Uniswap pool, instead of selling their tokens."
    ]
  },
  tokenomics: {
    cards: [
      { title: 'LP Renounced', text: "Can't rug this. Liquidity locked forever.", link: 'https://etherscan.io/tx/0xf217860ed0a81197c4f8df5ed0c6c50946ee38aecbc3f62efc72612c8d4cb8f5' },
      { title: 'CONTRACT', text: 'Locked forever', link: 'https://etherscan.io/tx/0x024f8a56b4e8c6176e6ff9007a9f19d66f46babdec70ad3cedd8ae275b3bdf5d' },
      { title: 'Tax', text: '0%', link: 'https://etherscan.io/tx/0x2cb72b1b92f6520afb43abf6d16713f81f025ed76657cf215d54f0b90f5e08d3' },
      { title: 'FIXED SUPPLY', text: '420 690 000 000 000 $ZEUS', link: 'https://etherscan.io/tx/0x4cf68a9a8e8a249ce3b188091ee1e9df5e53a4ccd2d3394ac1703660efcfedc1' }
    ],
    verifyText: "Each one links to the transaction on Etherscan, so you can check it yourself."
  },
  artist: {
    paragraphs: [
      "On February 7, 2022, ndhaus drew \"The Happiness of Zeus\" as a personal gift for Jon \"Jagged\" Eyrick, the owner of the real Zeus. There was no plan behind it. She just drew his dog in the Boy's Club style.",
      "Then Zeus started showing up in new Pepe art. Fan artists picked him up, and the Rare Pepes community began calling him \"Pepe's dog\".",
      "Today ndhaus is Creative Director and Principal Advisor of ZEUS CC8. She leads the comic series, picks the artists we work with and makes sure Zeus still looks and feels like her dog in everything we make.",
      "She did not join for the money. The project grew around her art, because without her drawing there would be no Zeus.",
      "Many memecoins use art taken from someone else. Here the artist who created the character sits with the team and has a say in every decision about him."
    ],
    links: {
      ndhaus: "https://x.com/ndhaus_",
      jagged: "https://x.com/jaggedsoft"
    }
  },
  dollarize: {
    title: 'ZEUS HAS ITS OWN STABLECOIN',
    paragraphs: [
      'USDZEUS is the stablecoin of ZEUS. Each one is backed by USDC and you can redeem it whenever you want.',
      'It runs on dollarize, a launchpad that gives memecoins a stablecoin of their own. ZEUS was the first.',
      'Every time someone mints USDZEUS, part of that money goes into a ZEUS/USDZEUS pool on Uniswap that nobody can ever withdraw. Liquidity goes in and never comes out, like a black hole, so the pool only grows.',
      'The fees that pool earns go to the people who stake their USDZEUS.',
    ],
    mintLink: 'https://dollarize.fun/stablecoins/0x0f7dc5d02cc1e1f5ee47854d534d332a1081ccc8#mint',
    howLink: 'https://dollarize.fun/how-it-works',
  },
  nfts: {
    title: 'DREAMSCAPE OF ZEUS',
    paragraphs: [
      'Dreamscape of Zeus is a collection of 140 one of a kind portraits drawn by ndhaus on Ethereum.',
      'In each one Zeus becomes someone else: a cowboy, an astronaut, a rock star, a painter. Same dog, a different dream every time.',
    ],
    link: 'https://opensea.io/collection/dreamscape-of-zeus',
    items: ['12', '120', '149', '142', '146', '112', '141', '147', '106', '140'],
  },
  comic: {
    subtitle: "This comic was hand-drawn and published in September 2025 by ndhaus, the artist behind this project."
  }
};
